export default __webpack_public_path__ + "static/media/GlassJoe-Final.c9934311.mp3";